
import { CirclePercent } from "lucide-react";
import { formatUnit, formatValue } from "@/utils/habitUtils";

interface HabitCardProgressProps {
  completedDays: number;
  totalDays: number;
  dailyTarget?: {
    value: number;
    unit: string;
  };
  dailyProgress?: number;
}

export const HabitCardProgress = ({
  completedDays,
  totalDays,
  dailyTarget,
  dailyProgress
}: HabitCardProgressProps) => {
  const progress = (completedDays / totalDays) * 100;

  return (
    <div className="flex items-center gap-8">
      <div className="relative w-20 h-20">
        <CirclePercent className="w-20 h-20 text-gray-200" strokeWidth={2} />
        <div
          className="absolute inset-0 flex items-center justify-center"
          style={{
            background: `conic-gradient(#9b87f5 ${progress}%, transparent ${progress}%)`,
            borderRadius: "50%",
          }}
        >
          <div className="bg-white rounded-full w-16 h-16 flex items-center justify-center">
            <span className="text-lg font-semibold text-primary">
              {Math.round(progress)}%
            </span>
          </div>
        </div>
      </div>
      <div className="text-sm text-gray-600 space-y-1">
        <div>{completedDays} days completed</div>
        <div>{totalDays - completedDays} days remaining</div>
        {dailyTarget && (
          <div className="space-y-1">
            <div className="text-primary font-medium">
              Progress: {formatValue(dailyProgress || 0, dailyTarget.unit)}/{formatValue(dailyTarget.value, dailyTarget.unit)} {formatUnit(dailyTarget.unit)}
            </div>
            {dailyProgress !== undefined && 
             dailyProgress < dailyTarget.value && (
              <div className="text-orange-500 font-medium">
                Remaining: {formatValue(dailyTarget.value - dailyProgress, dailyTarget.unit)} {formatUnit(dailyTarget.unit)}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
